import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../molecules/RoundedModal'
import SydButton from '../../../commonDesign/Button'
import SydModalActions from '../../../commonDesign/SydModal/SydModalActions'

const DeleteScheduleDialog = React.forwardRef(function DeleteScheduleDialog ({ onConfirm }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false, schedule: null })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false, schedule: null })
  }, [])

  const handleConfirm = useCallback(async () => {
    try {
      setDialogState((prev) => ({ ...prev, processing: true }))
      await onConfirm(dialogState.schedule)
    } finally {
      close()
    }
  }, [dialogState.schedule, onConfirm, close])

  useImperativeHandle(ref, () => ({
    open: (schedule) => {
      setDialogState({ open: true, processing: false, schedule: structuredClone(schedule) })
    }
  }), [])

  return (
    <RoundedModal
      title='Delete Schedule'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <>
            <p>
              Are you sure you want to delete schedule{' '}
              <strong>{dialogState.schedule?.name}</strong>? This action cannot be undone.
            </p>
            <SydModalActions>
              <SydButton disabled={dialogState.processing} variant='ghost' size='md' onClick={close}>
                Cancel
              </SydButton>
              <SydButton
                processing={dialogState.processing}
                variant='primary'
                priority='warning'
                icon='delete'
                size='md'
                onClick={handleConfirm}
              >
                Delete
              </SydButton>
            </SydModalActions>
          </>
        ) : null}
      </div>
    </RoundedModal>
  )
})

DeleteScheduleDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired
}

export default DeleteScheduleDialog
